import { ModuleWithProviders, NgModule } from '@angular/core';

import { ReportTemplateAdapterService } from 'shared/report-template/report-template-adapter';
import {
    DtoToTemplateHelperService,
    TemplateToDtoHelperService,
} from 'shared/report-template/report-template-adapter/helper';

import { ReportsConfiguration } from './configuration';
import { ReportModelService } from './report-model.service';

@NgModule()
export class ReportModelModule {
    static forRoot(): ModuleWithProviders<ReportModelModule> {
        return {
            ngModule: ReportModelModule,
            providers: [
                ReportModelService,
                ReportsConfiguration,
                ReportTemplateAdapterService,
                DtoToTemplateHelperService,
                TemplateToDtoHelperService,
            ],
        };
    }
}
